import React from 'react';
import { Box, Typography } from '@mui/material';
import { DoneAll } from '@mui/icons-material';
import { wa } from './waTheme';

/** A WhatsApp chat as the member sees it — sender header + template bubble. */
const WhatsAppPhonePreview: React.FC<{
  senderName: string;
  message?: string;
  caption?: string;
}> = ({ senderName, message, caption }) => (
  <Box
    sx={{
      width: '100%',
      maxWidth: 320,
      mx: 'auto',
      borderRadius: 5,
      overflow: 'hidden',
      border: '8px solid #111',
      boxShadow: '0 20px 50px rgba(0,0,0,0.18)',
      bgcolor: wa.chatBg,
    }}
  >
    <Box sx={{ bgcolor: wa.dark, color: '#fff', px: 1.5, py: 1.2, display: 'flex', alignItems: 'center', gap: 1.2 }}>
      <Box
        sx={{
          width: 32, height: 32, borderRadius: '50%', bgcolor: 'rgba(255,255,255,0.2)',
          display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 800, fontSize: 13,
        }}
      >
        {senderName.slice(0, 2).toUpperCase()}
      </Box>
      <Box sx={{ minWidth: 0 }}>
        <Typography sx={{ fontWeight: 700, fontSize: 14, lineHeight: 1.2 }} noWrap>{senderName}</Typography>
        <Typography sx={{ fontSize: 11, opacity: 0.75 }}>Business account</Typography>
      </Box>
    </Box>
    <Box
      sx={{
        minHeight: 220, p: 1.5, display: 'flex', flexDirection: 'column', justifyContent: 'flex-end',
        backgroundImage: 'radial-gradient(rgba(0,0,0,0.035) 1px, transparent 1px)', backgroundSize: '14px 14px',
      }}
    >
      {message ? (
        <Box
          sx={{
            alignSelf: 'flex-start', maxWidth: '88%', bgcolor: '#fff', borderRadius: '0 10px 10px 10px',
            px: 1.3, pt: 0.9, pb: 0.5, boxShadow: '0 1px 1px rgba(0,0,0,0.12)', position: 'relative',
          }}
        >
          <Typography sx={{ fontSize: 13.5, whiteSpace: 'pre-wrap', wordBreak: 'break-word', color: '#111' }}>
            {message}
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 0.4, mt: 0.2 }}>
            <Typography sx={{ fontSize: 10.5, color: 'rgba(0,0,0,0.45)' }}>10:00</Typography>
            <DoneAll sx={{ fontSize: 14, color: '#53bdeb' }} />
          </Box>
        </Box>
      ) : (
        <Typography sx={{ fontSize: 12.5, color: 'rgba(0,0,0,0.45)', textAlign: 'center', mb: 6 }}>
          Pick a template to see the message
        </Typography>
      )}
    </Box>
    {caption && (
      <Box sx={{ bgcolor: '#f7f7f7', px: 1.5, py: 1 }}>
        <Typography sx={{ fontSize: 11.5, color: 'text.secondary' }}>{caption}</Typography>
      </Box>
    )}
  </Box>
);

export default WhatsAppPhonePreview;
